module.exports = __webpack_public_path__ + "static/media/pulsar_dark_large.2a5e8df9.png";